export default class TiposDeSecoesEnum {
  static Mensagens = 1
  static Personalizada = 2
  static DadosDoCliente = 3
}
